import { render } from "./PayoutBreakdown.vue?vue&type=template&id=22f5f4aa&scoped=true"
import script from "./PayoutBreakdown.vue?vue&type=script&lang=js"
export * from "./PayoutBreakdown.vue?vue&type=script&lang=js"

import "./PayoutBreakdown.vue?vue&type=style&index=0&id=22f5f4aa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f5f4aa"]])

export default __exports__